import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import { withRenderToasters } from 'utils/hoc/withRenderToasters'
import withRouterCustom from 'utils/hoc/withRouterCustom'
import { withLaunchDarkly } from 'utils/sdks/launchDarkly.v2'
import { withMixpanel } from 'utils/sdks/mixpanel'

import {
  getAccountId,
  getAccountProfileName,
  isAccountTypeBrand,
  isLiteRetailer,
} from 'store/currentUser/selectors'
import { setOrdersModal } from 'store/modal/actions'
import {
  renderErrorNotification,
  renderNotification,
  renderSuccessNotification,
} from 'store/notificationHandler/actions'
import {
  changePageSize,
  resetSelectedOrders,
  toggleOrder,
  toggleSelectOrdersOnPage,
} from 'store/orderList/actions'
import {
  allOrdersAreSelected,
  filterSelectedOrders,
  getSelectedOrdersIds,
  isOrderSelected,
} from 'store/orderList/selectors'
import {
  getAppliedFilters,
  getSearchFilter,
} from 'store/orderListFilters/selectors'
import { setPageLoaderActive } from 'store/pageLoader/actions'

import { withAnalytics } from './OrderList.analytics'
import OrderListPage from './OrderList.component'
import {
  withOrderExportTasks,
  withRetailerOrders,
  withRetailerOrdersStaticCounts,
  withRetailerOrdersTotal,
} from './OrderList.queries'
import { withVAAccess } from './withVAAccess'
import withModal from 'containers/ModalHandler'

const mapStateToProps = (state) => ({
  allOrdersAreSelected: allOrdersAreSelected(state),
  appliedFilters: getAppliedFilters(state),
  currentUser: state.currentUser,
  filterSelectedOrders: filterSelectedOrders(state),
  isBrandUser: isAccountTypeBrand(state),
  isLiteRetailerUser: isLiteRetailer(state),
  isOrderSelected: isOrderSelected(state),
  orderBy: state.orderList.orderBy,
  pageSize: state.orderList.pageSize,
  selectedOrdersIds: getSelectedOrdersIds(state),
  searchFilter: getSearchFilter(state),
  accountId: getAccountId(state),
  accountName: getAccountProfileName(state),
})

const mapDispatchToProps = {
  changePageSize,
  handleResetSelectedOrders: resetSelectedOrders,
  openModal: setOrdersModal,
  renderErrorNotification,
  renderNotification,
  renderSuccessNotification,
  setPageLoaderActive,
  toggleOrder,
  toggleSelectOrdersOnPage,
}

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withLaunchDarkly,
  withMixpanel,
  withRouterCustom,
  withModal,
  withRedux,
  withAnalytics,
  withRetailerOrders,
  withRetailerOrdersTotal,
  withRetailerOrdersStaticCounts,
  withRenderToasters,
  withOrderExportTasks,
  withVAAccess,
)(OrderListPage)
